import SuperTokens from 'supertokens-auth-react';
import EmailPassword from 'supertokens-auth-react/recipe/emailpassword';
import Session from 'supertokens-auth-react/recipe/session';
import { languageTranslations } from './SuperTokens/superTokens_translations';
import EmailVerification from 'supertokens-auth-react/recipe/emailverification';

const getBackendUrl = () =>
  import.meta.env.DEV ? 'http://localhost:8008' : import.meta.env.VITE_BACKEND_URL || '';

const getFrontendUrl = () =>
  import.meta.env.DEV ? 'http://localhost:3000' : import.meta.env.VITE_FRONTEND_URL || '';

export const init_supertokens = () => {
  SuperTokens.init({
    languageTranslations: languageTranslations,
    appInfo: {
      // learn more about this on https://supertokens.com/docs/emailpassword/appinfo
      appName: 'test',
      apiDomain: getBackendUrl(),
      websiteDomain: getFrontendUrl(),
      apiBasePath: '/',
      websiteBasePath: '/auth',
    },
    recipeList: [
      EmailVerification.init({
        mode: 'REQUIRED', // or "OPTIONAL"
        useShadowDom: false,
        style: `
                         [data-supertokens~=button] {
                    color: white;
                    border-color: #357bc1;
                    background-color:#357bc1;
                    border-radius: 12px;
                  }
                    `,
      }),
      EmailPassword.init({
        getRedirectionURL: async (context) => {
          if (context.action === "SUCCESS") {
            try {
              // Check if the user's email is verified
              const isVerified = await EmailVerification.isEmailVerified();
              if (!isVerified.isVerified) {
                return "/auth/verify-email";
              }
              return "/";
            } catch (err) {
              console.error("Error checking email verification status:", err);
              // If check fails, assume unverified and redirect to verification page
              // This ensures the email sending is triggered
              return "/auth/verify-email";
            }
          }
          return undefined;
        },
        style: `
                  [data-supertokens~=superTokensBranding] {
                      display:none;
                  }

                  [data-supertokens~=container] {
                    box-shadow: none;
                    margin-top:0px;
                    margin-bottom:0px;
                    font-family:'Dax-Pro-Regular';
                    --palette-primary: 53, 122, 193;
                  }
                  [data-supertokens~=button] {
                    color: white;
                    border-color: #357bc1;
                    background-color:#357bc1;
                    border-radius: 12px;
                  }
                  [data-supertokens~=row] {
                    padding-top:10px;
                    padding-bottom:10px
                  }
                  [data-supertokens~=formRow ] {
                    padding-top:10px;
                    padding-bottom:10px
                  }
              `,
        useShadowDom: false,

        signInAndUpFeature: {
          signUpForm: {
            formFields: [
              {
                id: 'name',
                label: 'Vor- und Nachname',
                placeholder: 'Max Mustermann',
              },
              {
                id: 'terms',
                label: '',
                optional: false,
                nonOptionalErrorMsg:
                  'Sie müssen die Nutzungsbedingungen und Datenschutzrichtlinien akzeptieren',
                inputComponent: ({ name, onChange }) => (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'left',
                      marginBottom: ' -12px',
                    }}>
                    <input
                      name={name}
                      type='checkbox'
                      onChange={(e) => onChange(e.target.checked.toString())}></input>
                    <span style={{ marginLeft: 5, textAlign: 'left' }}>
                      Ich stimme den{' '}
                      <a
                        href={getFrontendUrl() + '/terms-of-service'}
                        data-supertokens='link'>
                        Nutzungsbedingungen
                      </a>
                      und{' '}
                      <a
                        href={getFrontendUrl() + '/privacy-policy'}
                        data-supertokens='link'>
                        Datenschutzrichtlinien
                      </a>
                      zu
                    </span>
                  </div>
                ),
              },
            ],
          },
        },
      }),
      Session.init(),
    ],
  });
};
